import { camelToSnakeCase } from './camel-to-snake-case';

/* Copy object while converting all keys from camel to snake case */
export function snakeCaseCopy(object) {
  const output = {};
  Object.keys(object).forEach(key => {
    output[camelToSnakeCase(key)] = object[key];
  });
  return output;
}
//# sourceMappingURL=snake-case-copy.js.map